<div class="row" [class.w-100]="fullwidth" [class.relative]="relative">
    <input type="text" ngxDaterangepickerMd [(ngModel)]="selection" [locale]='days' [singleDatePicker]="true" [autoApply]="true" [disabled]="disabled"
           (click)="openDatepicker()" [drops]="dropDown?'down':'up'" (change)="change($event)" [ngClass]="{'disabled': disabled}" />
    <div class="placeholder-container">
        <span class="placeholder">{{ label }}</span>
    </div>
</div>